import { Environment } from '@definitions/env'
import { LoggingLevel, LoggingService } from '@enums/logging'

export const environment: Environment = Object.freeze({
	production: true,
	urlPrefix: 'https://api-mobile.corepark.com/partner/guest',
	squareScript: 'https://js.squareup.com/v2/paymentform',
	endpoint: 'https://api-web.corepark.com',
	rootUrl: 'https://guest.corepark.com',
	freedompayScript: 'https://hpc.freedompay.com/api/v1.5/cdn/hpc_min.js',
	reCaptcha: {
		siteKey: '6LfFzoUrAAAAAMBnhQYzwtMyXXZzoMQLMWi7Pfg3',
	},
	logging: {
		level: LoggingLevel.Warn,
		service: LoggingService.Bugfender,
		loggingConfig: {
			appKey: 'EmTREb2PRDGNYCXmk4fur2EXmaJtobBF',
		},
	},
})
